import React from 'react';
import bannerWeb from '../../assets/bannerosweb.jpg';
import bannerIpad from '../../assets/bannerosipad.jpg';
import bannerPhone from '../../assets/bannerosphone.jpg';

const ServiceHero = () => {
  return (
    <section className="relative w-full">
      <picture>
        <source media="(min-width: 1024px)" srcSet={bannerWeb} />
        <source media="(min-width: 768px)" srcSet={bannerIpad} />
        <img 
          src={bannerPhone} 
          alt="Our services" 
          className="w-full h-auto object-cover" 
        />
      </picture>
    </section>
  );
};

export default ServiceHero;
